<template>
  <div class="home">
    <div class="banner" id="banner">
      <CommonBanner />
    </div>
    <!-- 中心内容 -->
    <div class="contentCenter">
      <!-- 培训流程及新闻资讯 -->
      <div class="middle">
        <div class="processAndNew">
          <div class="process">
            <div
              class="publicTitle display-flex justify-content-space-between align-items-center"
            >
              <h5 class="h5">
                <img src="../assets/img/titleLine.png" alt /> 学习流程
              </h5>
            </div>

            <ul class="flowPath">
              <li>

                <div class="img">
                  <Tooltip content="(1）登录全国会计人员统一服务平台提交信息采集资料审核，注册/登录爱尔信学习系统学习、考试。
注意：若未完成会计人员信息采集，在学习系统完成的继续教育课程学习记录、考试记录无法上传到会计人员管理系统（时间紧迫的情况下时候可以边学习继续教育网络课程边提交信息采集等待对应财政部门审核）
（2）无需在云南省会计人员管理系统报名对应继续教育年份。" placement="top-start" max-width="300">
                  <img src="../assets/img/registerImg.png" alt="报名" />
                  <p class="label" v-if="special == null">报名</p>
                  <p class="label" v-else>登录</p>
                  </Tooltip>
                </div>
                <div class="arrow">
                  <span class="line"></span>
                  <span class="arrowRight"></span>
                </div>

              </li>
              <li v-if="special == null">
                <div class="img">
                  <Tooltip content="（1）点击“课程中心”进行购买。每年合格的会计人员继续教育学分是不少于90学分，三个学分为一个学时，因此，30学时即为合格。30学时里面包括10个公需学时，20个专业学时。购买课程时可选择60元90学分，亦可根据自己的实际需要进行购买。" placement="top-start" max-width="300">
                  <img src="../assets/img/pay.png" alt="注册网上支付信息" />
                  <p class="label">网上支付</p>
                  </Tooltip>
                </div>
                <div class="arrow">
                  <span class="line"></span>
                  <span class="arrowRight"></span>
                </div>
              </li>
              <li>
                <div class="img">
                  <Tooltip content="（1）点击“学习中心”，点击绿色按钮“去选课”进行选课（选课以后才可以听课学习哦）
（2）在选择课程时满足30学时，即专业课20学时，公需课 10 学时。学时选够时，页面底部的进度条确认按钮会变成橙色，点确定，再点击最右上角“学习中心”返回，最后点击听课按钮即可进入听课。" placement="top-start" max-width="300">
                  <img src="../assets/img/selected.png" alt="选课学习" />
                  <p class="label">选课学习</p>
                  </Tooltip>
                </div>
                <div class="arrow">
                  <span class="line"></span>
                  <span class="arrowRight"></span>
                </div>
              </li>
              <li>
                <div class="img">
                  <Tooltip content="（1）学满已选学时，即可进入考试。考试60分合格，不限次数，考试合格后生成合格证，自行打印或下载即可。" placement="top-start" max-width="300">
                  <img src="../assets/img/test.png" alt="在线考试" />
                  <p class="label">在线考试</p>
                  </Tooltip>
                </div>
                <div class="arrow">
                  <span class="line"></span>
                  <span class="arrowRight"></span>
                </div>
              </li>
              <li>
                <div class="img">
                  <Tooltip content="（1）点击“学习中心”--打印学习合格证" placement="top-start" max-width="300">
                  <img src="../assets/img/voucher.png" alt="打印学习合格证" />
                  <p class="label">打印凭证</p>
                  </Tooltip>
                </div>
                <div class="arrow" v-if="special == null">
                  <span class="line"></span>
                  <span class="arrowRight"></span>
                </div>
              </li>
              <li>
                <div class="img" v-if="special == null">
                  <Tooltip content="（1）考试合格后将统一上传数据到对应财政部门审核，各位学员无需自己上传合格证。
" placement="top-start" max-width="300">
                  <img src="../assets/img/examine.png" alt="登记审核" />
                  <p class="label">登记审核</p>
                  </Tooltip>
                </div>
                <!-- <div class="arrow">
                  <span class="line"></span>
                  <span class="arrowRight"></span>
                </div>-->
              </li>
            </ul>
          </div>
          <div class="news">
            <div
              class="publicTitle display-flex justify-content-space-between align-items-center"
            >
              <h5 class="h5">
                <img src="../assets/img/titleLine.png" alt /> 新闻资讯
              </h5>

              <router-link to="/news" class="more" v-if="newsList.length > 4"
                >更多</router-link
              >
            </div>
            <ul class="newList">
              <li v-for="item in newsList.slice(0, 4)" :key="item.id">
                <p class="synopsis" @click="handletoDetail(item)">
                  {{ item.title }}
                </p>
                <span class="date">{{ item.createtime.split(" ")[0] }}</span>
              </li>
            </ul>
          </div>
        </div>
        <div class="right">
          <div v-if="!token" class="regAndLogin">
            <img src="../assets/img/loginImg.png" alt="登陆" />
            <div class="button" style="justify-content: center;">
              <button class="btnLogin" @click="handleLogin">登录</button>
              <button class="btnResgiter" @click="handleRegister" v-if="special == null" >注册</button>
            </div>
          </div>
          <div v-else class="logined">
            <div class="userInfo" style="text-align: center;">
              <img
                v-if="userInfo.headimg"
                :src="userInfo.headimg"
                onerror="javascript:this.src='../assets/img/header.jpg'"
                alt="头像"
              />
              <img
                v-else
                src="../assets/img/header.jpg"
                onerror="javascript:this.src='../assets/img/header.jpg'"
                alt="头像"
              />
              <div class="info">
                <span class="name">
                  {{ userInfo.name }}
                  <i>{{ userInfo.cztype }}</i>
                </span>
                <!-- <span class="time">
                  {{ userInfo.totalTime }}学时
                  <span class="count">已考次数{{ userInfo.examnum }}/10</span>
                </span>-->
                <!-- <span class="t1">
                  专业课学分
                  <i v-if="userInfo.zyk">
                    {{ userInfo.zybasepoint }} ({{
                      userInfo.zyk.exchangeTime
                    }}学时)
                  </i>
                </span>
                <span class="t2">
                  公需课学分
                  <i v-if="userInfo.gxk">
                    {{ userInfo.gxbasepoint }} ({{
                      userInfo.gxk.exchangeTime
                    }}学时)
                  </i>
                </span> -->
              </div>
            </div>
            <!-- <div class="progress">
              <div id="progress" v-if="userInfo.zyk">
                <div class="display-flex">
                  <span class="label">{{ userInfo.zyk.type }}</span>
                  <div class="proLength">
                    <Progress
                      status="active"
                      :percent="userInfo.zyk.progress"
                      :stroke-color="['#31AF58', '#31AF58']"
                      :stroke-width="10"
                      hide-info
                    ></Progress>
                  </div>
                  <span class="p p1">
                    <i>{{ userInfo.zyk.studyTime }}/</i>
                    {{ userInfo.zyk.examTime }}
                  </span>
                </div>
                <div class="display-flex">
                  <span class="label">{{ userInfo.gxk.type }}</span>
                  <div class="proLength">
                    <Progress
                      status="active"
                      :percent="userInfo.gxk.progress"
                      :stroke-color="['#EC6941', '#EC6941']"
                      :stroke-width="10"
                      hide-info
                    ></Progress>
                  </div>
                  <span class="p p2">
                    <i>{{ userInfo.gxk.studyTime }}/</i>
                    {{ userInfo.gxk.examTime }}
                  </span>
                </div>
                <div class="display-flex" v-if="userInfo.bk.type">
                  <span class="label">{{ userInfo.bk.type }}</span>
                  <div class="proLength">
                    <Progress
                      status="active"
                      :percent="userInfo.bk.progress"
                      :stroke-color="['#BFAC8E', '#BFAC8E']"
                      :stroke-width="10"
                      hide-info
                    ></Progress>
                  </div>
                  <span class="p p3">
                    <i>{{ userInfo.bk.studyTime }}/</i>
                    {{ userInfo.bk.examTime }}
                  </span>
                </div>
              </div>
            </div>-->
            <div class="btn display-flex">
              <button type="button" class="continue" @click="handleStudent">
                继续学习
              </button>
              <Poptip confirm title="确定退出登录?" @on-ok="handleLogOut">
                <!-- <Button>Delete</Button> -->
                <button type="button" class="logOut">退出登录</button>
              </Poptip>
            </div>
          </div>
          <ul>
            <li>
              <!-- <router-link to> -->
              <a href="http://fg.aierxin.cn" target="_blank">
                <div class="img">
                  <img src="../assets/img/balance.png" alt="财经法规" />
                  <p class="label">财经法规</p>
                </div>
              </a>
              <!-- </router-link> -->
            </li>
            <li>
              <router-link to="/notice">
                <div class="img">
                  <img src="../assets/img/notice.png" alt="教育须知" />
                  <p class="label">教育须知</p>
                </div>
              </router-link>
            </li>
            <li @click="handleToProblem">
              <router-link to>
                <div class="img">
                  <img src="../assets/img/problem.png" alt="我的问题" />
                  <p class="label">我的问题</p>
                </div>
              </router-link>
            </li>
          </ul>
        </div>
      </div>
      <div class="combo" v-if="special == null">
        <div
          class="publicTitle display-flex justify-content-space-between align-items-center"
        >
          <h5 class="h5">
            <img src="../assets/img/titleLine.png" alt /> 推荐套餐
          </h5>
          <div @click="handleShopCombo">
            <router-link to class="more" v-if="combo.length > 4"
              >更多</router-link
            >
          </div>
        </div>
        <ul class="list display-flex">
          <li
            class="item"
            v-for="item in combo.slice(0, 4)"
            :key="item.id"
            @click="handleToComboDetail(item.id)"
          >
            <div class="inner">
              <img v-if="item.imgurl" :src="item.imgurl" alt />
              <img v-else src="../assets/images/proof.jpg" alt />
              <h5>{{ item.name }}</h5>
              <p class="price">
                ￥
                <span>{{ item.money }}</span>
              </p>
            </div>
          </li>
        </ul>
      </div>
      <!-- 课程体系 -->
      <div class="curriculum" v-if="special == null">
        <div id="scollBox">
          <div
            class="publicTitle display-flex justify-content-space-between align-items-center"
          >
            <h5 class="h5">
              <img src="../assets/img/titleLine.png" alt /> 课程体系
            </h5>
          </div>
          <div class="courseShai">
            <div class="item">
              <p class="fl">学习年度</p>
              <ul class="publicUl">
                <li
                  @click="handleChangeYear(item)"
                  class="inner"
                  :class="item.className"
                  v-for="item in conditon.yearArr"
                  :key="item.id"
                >
                  {{ item.name }}
                </li>
              </ul>
            </div>
            <div class="item">
              <p class="fl">行业分类</p>
              <ul class="publicUl">
                <li
                  @click="handleChangeIndustry(item)"
                  class="inner"
                  :class="item.className"
                  v-for="item in conditon.industrys"
                  :key="item.id"
                >
                  {{ item.name }}
                </li>
              </ul>
            </div>
            <div class="item">
              <p class="fl">资质等级</p>
              <ul class="publicUl">
                <li
                  @click="handleChangeArxAptitude(item)"
                  class="inner"
                  :class="item.className"
                  v-for="item in conditon.arxAptitudes"
                  :key="item.id"
                >
                  {{ item.name }}
                </li>
              </ul>
            </div>
          </div>
          <div class="tabelHeader">
            <table>
              <thead>
                <tr>
                  <th style="width: 170px;">课程分类</th>
                  <th style="width: 200px;">科目分类</th>
                  <th style="width: 400px;">课程专题</th>
                  <th style="width: 200px;">学时</th>
                  <th style="width: 170px;">操作</th>
                </tr>
              </thead>
            </table>
          </div>
        </div>
        <div id="tabel">
          <Table
            stripe
            :show-header="false"
            :columns="columns"
            :data="list"
            border
            :span-method="handleSpan"
            :row-class-name="rowClassName"
          >
            <template slot-scope="{ row, index }" slot="action">
              <div
                class="auditionTd display-flex"
                @click="handletoVideoDetail(row)"
              >
                <div class="audition">
                  <!-- @click="handleAudition(row)" -->
                  <!-- v-if="row.isPlaying" -->
                  <!-- <img
                    style="width:26px"
                    src="../assets/img/playing.gif"
                    alt
                  />-->
                  <img src="../assets/img/play.png" alt />
                  <span>试听</span>
                </div>
                <!-- @click="handletoVideoDetail(row)" -->
                <div class="detail">
                  <router-link to>详情</router-link>
                </div>
              </div>
            </template>
          </Table>
        </div>
      </div>
    </div>
    <!--<ContactWay />-->
  </div>
</template>

<script>
import ContactWay from "@/components/ContactWay.vue";
import CommonBanner from "@/components/CommonBanner.vue";
import { postData, showLoading, EventBus } from "../assets/api/api.js";
export default {
  name: "Home",
  components: {
    ContactWay,
    CommonBanner,
  },
  data() {
    return {
      combo: [],
      token: "",
      page: 0,
      size: 10,
      columns: [
        {
          title: "课程分类",
          key: "type",
          align: "center",
          width: 170,
        },
        {
          title: "科目分类",
          key: "subName",
          align: "center",
          width: 200,
        },
        {
          title: "课程专题",
          key: "name",
          align: "left",
          width: 400,
        },
        // { title: "课件名称", key: "vidoname", align: "left", width: 400 },
        {
          title: "学时",
          key: "time",
          align: "center",
          width: 200,
        },
        {
          title: "操作",
          slot: "action",
          align: "center",
          width: 169,
        },
      ],
      list: [],
      getlist: [],
      currentAudio: "",
      newsList: [],
      conditon: {},
      aptitudeId: "", //资质id
      industryId: "", //行业id
      year: "", //年份
      special: null,
    };
  },
  created() {
    this.special = JSON.parse(localStorage.getItem("special"))
    this.getToten();
    const { token } = this;
    // this.list = this.formatData(this.lists);
    this.loadNews();
    this.loadQueryConditon();
    this.$store.commit("setIsHome", true);
    this.loadCombo();
  },
  beforeDestroy() {
    this.$store.commit("setIsHome", false);
    if (this.currentAudio) {
      this.currentAudio.pause();
    }
  },
  mounted() {
    EventBus.$on("loadUserInfo", () => {
      this.getToten();
      // this.loadUserInfo();
    });
    EventBus.$on("getToten", () => {
      this.getToten();
    });
    this.$nextTick(() => {
      setTimeout(() => {
        var postionDom = document.getElementById("scollBox");
        var tabelDom = document.getElementById("tabel");
        var domDistanceTop = postionDom.offsetTop;
        window.onscroll = function() {
          var scroolHeight =
            document.documentElement.scrollTop || document.body.scrollTop;
          if (scroolHeight >= domDistanceTop) {
            postionDom.style.position = "fixed";
            postionDom.style.top = 0;
            tabelDom.style.marginTop = postionDom.offsetHeight + "px";
          } else {
            postionDom.style.position = "static";
            tabelDom.style.marginTop = "0px";
          }
        };
      }, 2000);
    });
  },
  computed: {
    userInfo() {
      return this.$store.state.userStudyInfo;
    },
  },
  methods: {
    handleToComboDetail(id) {
      if (!this.token) {
        this.$Message.warning("您还未登录,请先登录!");
        EventBus.$emit("login");
      } else {
        this.$router.push({
          path: "/CurriculumSetMealInfo",
          query: {
            cid: id,
          },
        });
      }
    },
    handleShopCombo() {
      if (!this.token) {
        this.$Message.warning("您还未登录,请先登录!");
        EventBus.$emit("login");
      } else {
        this.$router.push({
          path: "/CurriculumSetMeal",
        });
      }
    },
    loadCombo() {
      postData("sale/recommend", {}).then((res) => {
        if (res) {
          if (res.data.length > 0) {
            this.combo = res.data.map((i) => {
              i.money = +i.money.toFixed(3);
              return i;
            });
          }
        } else {
          this.combo = [];
        }
      });
    },
    handleStudent() {
      if (!this.$store.state.master.user.phone) {
        this.$router.push({
          path: "/bindPhone",
        });
      } else {
        this.$router.push({
          path: "/attendanceProcess/combo",
        });
      }
    },
    getToten() {
      if (localStorage.getItem("master")) {
        if (JSON.parse(localStorage.getItem("master")).token) {
          if (JSON.parse(localStorage.getItem("master")).token.token) {
            this.token = JSON.parse(localStorage.getItem("master")).token.token;
          } else {
            this.token = "";
          }
        } else {
          this.token = "";
        }
      } else if (JSON.parse(sessionStorage.getItem("master"))) {
        if (JSON.parse(sessionStorage.getItem("master")).token) {
          if (JSON.parse(sessionStorage.getItem("master")).token.token) {
            this.token = JSON.parse(
              sessionStorage.getItem("master")
            ).token.token;
          } else {
            this.token = "";
          }
        } else {
          this.token = "";
        }
      } else {
        this.token = "";
      }
      if (this.token) {
        this.loadUserInfo();
      }
    },
    handletoVideoDetail(row) {
      // if (!this.token) {
      //   this.$Message.warning("您还未登录,请先登录!");
      //   EventBus.$emit("login");
      // } else {
      this.$router.push({
        path: "/CurriculumVideo",
        query: {
          specialId: row.id,
          comboId: row.comboId,
          shiting: true,
        },
      });
      // }
    },
    handleToProblem() {
      if (!this.token) {
        this.$Message.warning("您还未登录,请先登录!");
      } else {
        if (!this.$store.state.master.user.phone) {
          this.$router.push({
            path: "/bindPhone",
          });
        } else {
          this.$router.push({
            path: "/attendanceProcess/problem",
          });
        }
      }
    },
    // 试听
    handleAudition(item) {
      this.list.forEach((i) => {
        if (i.id == item.id) {
          i.isPlaying = !i.isPlaying;
          if (this.currentAudio) {
            this.currentAudio.pause();
          }
          if (i.isPlaying) {
            if (item.ypurl) {
              this.currentAudio = new Audio(item.ypurl);
              this.currentAudio.play();
              this.currentAudio.loop = false;
              this.currentAudio.addEventListener(
                "ended",
                () => {
                  i.isPlaying = false;
                },
                false
              );
            }
          }
        } else {
          i.isPlaying = false;
        }
      });
    },
    loadUserInfo() {
      this.$store.dispatch("getUserStudyInfo");
    },
    // shaixuan() {
    //   var industryId =
    //     this.conditon.industrys.find((i) => i.className == "active").id == "all"
    //       ? ""
    //       : this.conditon.industrys.find((i) => i.className == "active").id;
    //   var aptitudeId =
    //     this.conditon.arxAptitudes.find((i) => i.className == "active").id ==
    //     "all"
    //       ? ""
    //       : this.conditon.arxAptitudes.find((i) => i.className == "active").id;
    //   if (industryId != "" && aptitudeId == "") {
    //     this.list = this.formatData(
    //       this.getlist.filter((i) => i.industryids == industryId)
    //     );
    //   } else if (industryId == "" && aptitudeId != "") {
    //     this.list = this.formatData(
    //       this.getlist.filter((i) => i.aptitudeids == aptitudeId)
    //     );
    //   } else if (industryId != "" && aptitudeId != "") {
    //     this.list = this.formatData(
    //       this.getlist.filter(
    //         (i) => i.aptitudeids == aptitudeId && i.industryids == industryId
    //       )
    //     );
    //   } else {
    //     this.list = this.formatData(this.getlist);
    //   }
    // },
    loadCourseData() {
      var industryId =
        this.conditon.industrys.find((i) => i.className == "active").id == "all"
          ? ""
          : this.conditon.industrys.find((i) => i.className == "active").id;
      var aptitudeId =
        this.conditon.arxAptitudes.find((i) => i.className == "active").id ==
        "all"
          ? ""
          : this.conditon.arxAptitudes.find((i) => i.className == "active").id;
      var year =
        this.conditon.yearArr.find((i) => i.className == "active").name ==
        "全部"
          ? ""
          : this.conditon.yearArr.find((i) => i.className == "active").name;

      var params = {
        aptitudeId,
        industryId,
        year,
      };
      showLoading();
      postData("subject/listPage", params)
        .then((res) => {
          if (res.data) {
            if (res.data.entities) {
              res.data.entities.forEach((i, index) => {
                i.isPlaying = false;
              });
              //   this.getlist = this.formatData(res.data.entities);

              this.list = this.formatData(res.data.entities).map((i, index) => {
                if (i.time) {
                  i.time = i.time.toFixed(2);
                } else {
                  var time = 0;
                  i.time = time.toFixed(2);
                }
                return i;
              });
              //   console.info("listlist", this.list);
            } else {
              this.list = [];
            }
          } else {
            this.list = [];
          }
        })
        .catch((err) => {});
    },
    handleChangeYear(item) {
      this.conditon.yearArr.forEach((i) => {
        if (i.id == item.id) {
          i.className = "active";
        } else {
          i.className = "";
        }
      });
      this.loadCourseData();
    },
    handleChangeIndustry(item) {
      this.conditon.industrys.forEach((i) => {
        if (i.id == item.id) {
          i.className = "active";
        } else {
          i.className = "";
        }
      });
      //   this.shaixuan();
      this.loadCourseData();
    },
    handleChangeArxAptitude(item) {
      this.conditon.arxAptitudes.forEach((i) => {
        if (i.id == item.id) {
          i.className = "active";
        } else {
          i.className = "";
        }
      });
      //   this.shaixuan();
      this.loadCourseData();
    },
    loadQueryConditon() {
      postData("subject/getTryConditon", {}).then((res) => {
        if (res.data) {
          if (res.data.arxAptitudes.length > 0) {
            res.data.arxAptitudes.unshift({
              id: "all",
              name: "全部",
              className: "",
            });
            res.data.arxAptitudes.forEach((i, index) => {
              if (index == 0) {
                i.className = "active";
              } else {
                i.className = "";
              }
            });
          }
          if (res.data.industrys.length > 0) {
            res.data.industrys.unshift({
              id: "all",
              name: "全部",
              className: "",
            });
            res.data.industrys.forEach((i, index) => {
              if (index == 0) {
                i.className = "active";
              } else {
                i.className = "";
              }
            });
          }
          if (res.data.years.length > 0) {
            var yearArr = [];
            res.data.years.unshift("全部");
            res.data.years.forEach((i, index) => {
              var obj = {
                id: index,
                name: i,
                className: index == 0 ? "active" : "",
              };
              yearArr.push(obj);
            });
            res.data.yearArr = yearArr;
          }
          this.conditon = res.data;
        } else {
          this.conditon = {};
        }
        this.loadCourseData();
      });
    },
    // 跳转新闻详情
    handletoDetail(item) {
      this.$router.push({
        path: "/newsDetail",
        query: {
          id: item.id,
        },
      });
    },
    // 读取新闻数据
    loadNews() {
      const { page, size } = this;
      var params = {
        currentPage: page,
        pageSize: size,
      };
      postData("article/listPage", params).then((res) => {
        if (res.data) {
          if (res.data.entities) {
            this.newsList = res.data.entities;
            var ids =
              res.data.entities.length > 0
                ? res.data.entities.slice(0, 2).map((i) => i.id)
                : [];
            this.$store.state.newsId = ids;
          } else {
            this.newsList = [];
          }
        } else {
          this.newsList = [];
        }
      });
    },
    handleSpan({ row, column, rowIndex, columnIndex }) {
      if (columnIndex === 0) {
        return {
          rowspan: row.mergeCol0 === 0 ? 0 : row.mergeCol0,
          colspan: row.mergeCol0 === 0 ? 0 : 1,
        };
      }
      if (columnIndex === 1) {
        return {
          rowspan: row.mergeCol1 === 0 ? 0 : row.mergeCol1,
          colspan: row.mergeCol1 === 0 ? 0 : 1,
        };
      }
    },
    // 格式化数据  处理需要合并行或列
    formatData(data) {
      // 获取所有的不同课程  科目值
      let courseTypeArr = [];
      let subjectTypeArr = [];

      data.forEach((i) => {
        var courseObj;
        var subjectObj;
        if (courseTypeArr.length == 0) {
          courseObj = {
            id: i.id,
            type: i.type,
            subName: i.subName,
            mergeCol0: 0,
          };
          courseTypeArr.push(courseObj);
        } else {
          var item = courseTypeArr.find((j) => i.type == j.type);
          if (!item) {
            courseObj = {
              id: i.id,
              type: i.type,
              subName: i.subName,
              mergeCol0: 0,
            };
            courseTypeArr.push(courseObj);
          }
        }
        if (subjectTypeArr.length == 0) {
          subjectObj = {
            id: i.id,
            type: i.type,
            subName: i.subName,
            mergeCol1: 0,
          };
          subjectTypeArr.push(subjectObj);
        } else {
          var item = subjectTypeArr.find(
            (j) => i.type == j.type && i.subName == j.subName
          );
          if (!item) {
            subjectObj = {
              id: i.id,
              type: i.type,
              subName: i.subName,
              mergeCol1: 0,
            };
            subjectTypeArr.push(subjectObj);
          }
        }
      });
      courseTypeArr.forEach((i, index) => {
        i.sort0 = index;
      });
      subjectTypeArr.forEach((i, index) => {
        i.sort1 = index;
      });
      // 计算每个课程 科目的可跨行数
      data.forEach((k) => {
        courseTypeArr.forEach((l) => {
          k.type === l.type ? l.mergeCol0++ : l.mergeCol0;
        });
        subjectTypeArr.forEach((l) => {
          k.type === l.type && k.subName === l.subName
            ? l.mergeCol1++
            : l.mergeCol1;
        });
      });

      var courseArr = courseTypeArr.map((i) => i);
      var subjectArr = subjectTypeArr.map((i) => i);
      data.forEach((m) => {
        courseTypeArr.forEach((n, index) => {
          if (m.type === n.type) {
            m.sort0 = n.sort0;
            var idx = courseArr.map((i) => i.id).indexOf(m.id);
            if (idx != -1) {
              m.mergeCol0 = n.mergeCol0;
              courseArr.splice(idx, 1);
            } else {
              m.mergeCol0 = 0;
            }
          }
        });
        subjectTypeArr.forEach((n, index) => {
          if (m.type === n.type && m.subName === n.subName) {
            m.sort1 = n.sort1;
            var idx = subjectArr.map((i) => i.id).indexOf(m.id);
            if (idx != -1) {
              m.mergeCol1 = n.mergeCol1;
              subjectArr.splice(idx, 1);
            } else {
              m.mergeCol1 = 0;
            }
          }
        });
      });

      data.sort(function(a, b) {
        return (
          a.sort0 - b.sort0 ||
          a.sort1 - b.sort1 ||
          b.mergeCol1 - a.mergeCol1 ||
          a.id - b.id
        );
      });
      return data;
    },
    rowClassName(row, index) {
      if (index % 2 == 0) {
        return "oddRow";
      } else {
        return "evenRow";
      }
      return "";
    },
    handleLogOut() {
      EventBus.$emit("loginOut");
    },
    handleLogin() {
      EventBus.$emit("login");
    },
    handleRegister() {
      EventBus.$emit("register");
    },
    register() {
      EventBus.$emit("register");
    },
  },
};
</script>
<style lang="scss">
#tabel {
  // .ivu-table .oddRow td {
  //   height: 50px;
  //   // border: 1px solid rgba(233, 232, 237, 1);
  //   background: rgba(255, 255, 255, 1);
  // }
  // .ivu-table .evenRow td {
  //   background-color: #fcfafa;
  //   height: 50px;
  // }
  .auditionTd {
    overflow: hidden;
    // padding-left: 20px;
    // padding-right: 20px;
    .audition {
      cursor: pointer;
      margin-right: 15px;
      float: left;
      img {
        vertical-align: middle;
        border: 1px solid transparent;
        // width: 12px;
        // height: 20px;
      }
      span {
        display: inline-block;
        font-size: 14px;
        font-weight: 400;
        color: rgba(0, 0, 0, 1);
        line-height: 20px;
      }
    }
    .audition.active {
      img {
        border: 1px dashed #aaa;
      }
      span {
        color: #ec6941;
      }
    }
    .audition:hover {
      img {
        border: 1px dashed #aaa;
      }
    }
    .detail {
      float: right;
      a {
        padding: 0 10px;
        background: #fff;
        border: 1px solid rgba(0, 0, 0, 1);
        color: #000;
        border-radius: 10px;
        font-size: 14px;
      }
    }
  }
}
</style>
<style lang="scss" scoped>
.combo {
  margin-bottom: 20px;
  background: #fff;
  .list {
    margin-left: 20px;
    margin-right: 20px;
    li:first-child {
      margin-left: 0;
    }
    li:last-child {
      margin-right: 0;
    }
    li {
      cursor: pointer;
      margin-bottom: 25px;
      margin-right: 13px;
      margin-left: 13px;
      img {
        width: 270px;
        height: 150px;
      }
      h5 {
        margin-top: 12px;
        font-size: 16px;
        color: rgba(34, 34, 34, 1);
        line-break: 20px;
      }
      p {
        margin-top: 10px;
        line-height: 24px;
        font-size: 22px;
        font-weight: bold;
        color: rgba(236, 105, 65, 1);
      }
    }
  }
}

.publicTitle {
  margin-bottom: 0px;
  padding: 15px 0;
  border-bottom: none;
  .h5 {
    img {
      vertical-align: middle;
    }
    font-size: 16px;
    color: rgba(34, 34, 34, 1);
  }
  .more {
    cursor: pointer;
    display: inline-block;
    margin-right: 20px;
    margin-top: 10px;
    width: 28px;
    font-size: 14px;
    font-weight: 400;
    color: rgba(153, 153, 153, 1);
    line-height: 20px;
  }
}

button {
  border: none;
  outline: none;
  cursor: pointer;
}

.logined {
  padding-left: 20px;
  background: #fff;
  margin-bottom: 10px;
  .btn {
    padding-left: 3px;
    padding-bottom: 33px;
    button {
      width: 110px;
      height: 36px;
      border-radius: 18px;
    }
    .continue {
      margin-right: 15px;
      color: #fff;
      background: rgba(0, 0, 0, 1);
    }
    .logOut {
      background: #fff;
      border: 1px solid rgba(0, 0, 0, 1);
    }
  }
  .progress {
    margin-top: 15px;
    margin-bottom: 18px;
    text-align: center;
    #progress {
      span.label {
        width: 40px;
        text-align: left;
      }
      p {
        color: #666;
      }
      .p1 {
        i {
          color: rgba(49, 175, 88, 1);
        }
        em {
          color: #a19fa0;
        }
      }
      .p2 {
        i {
          color: rgba(236, 105, 65, 1);
        }
        em {
          color: #a19fa0;
        }
      }
      .p3 {
        i {
          color: #bfac8e;
        }
      }
      .performed {
        color: rgba(49, 175, 88, 1);
      }
      .proLength {
        margin: 0 10px;
        width: 130px;
      }
      span {
        color: rgba(102, 102, 102, 1);
        font-size: 12px;
      }
    }
    h5 {
      color: rgba(236, 105, 65, 1);
    }
  }
  .userInfo {
    padding-top: 30px;
    padding-bottom: 40px;
    img {
      margin-top: 28px;
      width: 80px;
      height: 80px;
      border-radius: 50%;
      color: #fff;
      line-height: 20px;
      margin-right: 20px;
    }
    span {
      display: block;
    }
    .t1 {
      color: rgba(49, 175, 88, 1);
      i {
        margin-left: 10px;
      }
    }
    .t2 {
      color: rgba(236, 105, 65, 1);
      i {
        margin-left: 10px;
      }
    }
    .name {
      margin-top: 17px;
      font-size: 16px;
      color: rgba(34, 34, 34, 1);
      i {
        margin-left: 15px;
      }
    }
    .time {
      color: rgba(153, 153, 153, 1);
    }
    .count {
      display: inline-block;
      margin-left: 10px;
      // color: rgba(236, 105, 65, 1);
    }
  }
}

#tbody {
  td {
    text-align: center;
    font-size: 14px;
    font-weight: 400;
    color: rgba(102, 102, 102, 1);
    line-height: 40px;
    border: 1px solid #eaeaea;
  }
  td.odd {
    background: #fcf9fc;
  }
}

.tabelHeader {
  margin-top: 25px;
  margin-left: 30px;
  tr {
    background: #f2f2f2;
    font-size: 14px;
    font-weight: bold;
    color: rgba(0, 0, 0, 1);
    line-height: 48px;
    th {
      border: 1px solid #e8eaec;
      border-bottom: none;
    }
  }
}

.curriculum {
  background: white;
  margin-bottom: 30px;
  .courseShai {
    margin-left: 30px;
  }
  .item {
    overflow: hidden;
    margin-top: 12px;
    .fl {
      float: left;
      font-size: 14px;
      font-weight: 400;
      color: rgba(51, 51, 51, 1);
      line-height: 20px;
      margin-right: 25px;
    }
    .publicUl {
      width: 1060px;
      float: left;
      overflow: hidden;
      .inner {
        float: left;
        cursor: default;
        font-size: 14px;
        font-weight: 400;
        padding: 0 15px;
        font-weight: 400;
        color: rgba(102, 102, 102, 1);
        line-height: 24px;
      }
      .active {
        color: #fff;
        background: rgba(236, 105, 65, 1);
        border-radius: 5px;
      }
    }
  }
  #tabel {
    padding-bottom: 30px;
    width: 1141px;
    margin-left: 30px;
  }
}

#scollBox {
  z-index: 100;
  background: #fff;
  width: 1200px;
}

.newList {
  padding-top: 10px;
  margin-left: 30px;
  margin-right: 30px;
  display: flex;
  -webkit-flex-wrap: wrap;
  -webkit-box-lines: multiple;
  flex-wrap: wrap;
  justify-content: space-between;
}

.newList li {
  border-bottom: 1px dashed #bdbabd;
  display: flex;
  justify-content: space-between;
  margin-bottom: 20px;
  width: 400px;
  padding-bottom: 15px;
}

.newList .date {
  font-size: 14px;
  font-weight: 400;
  color: rgba(204, 204, 204, 1);
  line-height: 14px;
}

.newList .synopsis {
  cursor: pointer;
  width: 302px;
  font-size: 14px;
  font-weight: 400;
  color: rgba(102, 102, 102, 1);
  line-height: 16px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.home {
  background: #eef1ee;
  font-family: Microsoft YaHei;
}

.middle {
  padding-bottom: 20px;
  overflow: hidden;
}

.process {
  border-bottom: 1px solid #efedee;
  padding-bottom: 20px;
}

.processAndNew {
  background: #fff;
  float: left;
  width: 910px;
}

.regAndLogin {
  // padding-left: 20px;
  background: #fff;
  margin-bottom: 10px;
  text-align: center;
  padding-top: 66px;
  padding-bottom: 42px;
}

.regAndLogin img {
  margin-bottom: 40px;
  border: 1px dashed #aaa;
}

.regAndLogin .btnLogin {
  color: #fff;
  background: rgba(0, 0, 0, 1);
}

.btnResgiter {
  border: 1px solid #000 !important;
  background: transparent;
}

.regAndLogin .button {
  display: flex;
  justify-content: space-between;
  padding-left: 40px;
  padding-right: 40px;
}

.regAndLogin button {
  width: 90px;
  height: 36px;
  border-radius: 5px;
  border: none;
  margin: 0 8px;
}

.right ul {
  display: flex;
  justify-content: space-between;
}

.right ul li {
  text-align: center;
  width: 90px;
  background: #fff;
}

.right ul li a {
  display: inline-block;
}

.right ul li .label {
  margin-bottom: 0 !important;
  font-size: 14px;
  font-weight: 400;
  color: rgba(102, 102, 102, 1);
  line-height: 15px;
  margin-bottom: 15px;
  margin-top: -5px;
}

.right ul li img {
  margin-top: 3px;
  border: 1px dashed #aaa;
}

.right {
  width: 280px;
  float: right;
}

.flowPath {
  padding-left: 45px;
  overflow: hidden;
}

.flowPath .label {
  margin-top: -5px;
  text-align: center;
  font-size: 14px;
  font-weight: 400;
  color: rgba(51, 51, 51, 1);
  line-height: 20px;
}

.flowPath li {
  float: left;
  display: flex;
  align-items: center;
}

.flowPath li .img img {
  border: 1px dashed #aaa;
}

.flowPath .arrow {
  margin-left: 42px;
  margin-right: 20px;
}

.flowPath .arrowRight {
  display: inline-block;
  width: 0;
  height: 0;
  border-width: 7px;
  border-style: solid;
  border-color: transparent transparent transparent #979797;
  position: relative;
}

.flowPath .arrowRight::after {
  position: absolute;
  top: 50%;
  left: -27px;
  content: " ";
  height: 1px;
  width: 20px;
  /* transform: translateY(-50%); */
  /* transform: scaleY(0.9); */
  background: #979797;
}
</style>
